import { getVideoUrl } from '@/config/qiniu'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage } from '@/utils/layer'
import { useMount } from 'ahooks'
import React, { useRef } from 'react'
import './video-preivew.scss'

interface VideoPreviewProps {
    url: string
}

const VideoPreview: React.FC<VideoPreviewProps> = props => {
    const videoRef = useRef<HTMLVideoElement | null>(null)
    const cls = useBemClass('video-preview')

    useMount(() => {
        if (videoRef.current) {
            videoRef.current.src = getVideoUrl(props.url)
            videoRef.current.play()
        }
    })

    return (
        <div
            className={cls()}
            onClick={() => {
                layerManage.pop()
            }}
        >
            <video className={cls('video')} ref={videoRef} />
        </div>
    )
}

export default VideoPreview
